import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { IoIosArrowRoundBack } from "react-icons/io";
import { useSelector } from "react-redux";
import PageHeader from "../../../core/common/crmComponents/PageHeader";

const Profile = () => {
  const { user: userData } = useSelector((state) => state?.auth);
  const firstName = userData?.name?.split(" ")[0];
  const lastName = userData?.name?.split(" ")[1];

  const navigate = useNavigate();

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="row">
          <div className="col-md-12">
            <PageHeader pageName="Profile">
              <button
                className="p-2 btn btn-outline-none"
                onClick={() => navigate(-1)}
              >
                <IoIosArrowRoundBack className="d-inline" size={20} />
              </button>
            </PageHeader>

            <div className="row">
              <div className="col-lg-12">
                {/* Profile Information */}
                <div className="card">
                  <div className="card-body">
                    {/* First Name & Last Name */}
                    <div className="row mb-3">
                      <h5 className="fw-semibold mb-1">User Information</h5>

                      <div className="col-md-6">
                        <p>
                          <strong>First Name:</strong> {firstName || "N/A"}
                        </p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          <strong>Last Name:</strong> {lastName || "N/A"}
                        </p>
                      </div>

                      <div className="col-md-6">
                        <p className="">
                          <strong>Email:</strong> {userData?.email || "N/A"}
                        </p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          <strong>Phone:</strong> {userData?.mobile || "N/A"}
                        </p>
                      </div>
                      <div className="col-md-6">
                        <p className="text-capitalize">
                          <strong>Role:</strong>{" "}
                          {userData?.role?.name?.split("-").join(" ") || "N/A"}
                        </p>
                      </div>
                    </div>
                    <hr />

                    {/* Address Details */}
                    <div className="row mb-3">
                      <h5 className="fw-semibold mb-1">Address</h5>
                      <div className="col-md-6">
                        <p>
                          <strong>Street:</strong>{" "}
                          {userData?.address?.street || "N/A"}
                        </p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          <strong>City:</strong>{" "}
                          {userData?.address?.city || userData?.city || "N/A"}
                        </p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          <strong>State:</strong>{" "}
                          {userData?.address?.state || "N/A"}
                        </p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          <strong>Zipcode:</strong>{" "}
                          {userData?.address?.zipcode || "N/A"}
                        </p>
                      </div>
                    </div>

                    {/* Back Button */}
                    <div>
                      <Link
                        onClick={() => navigate(-1)}
                        className="btn btn-light"
                      >
                        Back
                      </Link>
                    </div>
                  </div>
                </div>
                {/* /Profile Information */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
